:host {
  display: block;
}

.pagination {
  font-family: var(--primary-font);
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  margin-bottom: 25px;

  .prev {
    position: relative;
    width: 25px;
    height: 25px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    background: var(--color-bleached-silk);

    a {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      border-radius: 50px;
      color: var(--color-nero);
      cursor: pointer;

      &:before {
        font-family: var(--primary-icon-font);
        font-size: 8px;
        content: '\e80d';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @include layerIndex('ground');
      }

      &:hover {
        color: var(--color-white);
        background: var(--color-livique-anthrazit);
      }

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }

  ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin: 0 10px;
      width: 25px;
      height: 25px;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background: var(--color-livique-anthrazit);

        a {
          color: var(--color-white);
        }
      }

      a {
        text-decoration: none;
        color: var(--color-nero);
        width: 25px;
        height: 25px;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
          color: var(--color-white);
          background: var(--color-livique-anthrazit);
        }
      }
    }
  }

  .next {
    position: relative;
    width: 25px;
    height: 25px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    background: var(--color-bleached-silk);

    a {
      position: relative;
      display: block;
      width: 25px;
      height: 25px;
      border-radius: 50px;
      cursor: pointer;
      color: var(--color-nero);

      &:before {
        font-family: var(--primary-icon-font);
        font-size: 8px;
        content: '\e80c';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @include layerIndex('ground');
      }

      &:hover {
        color: var(--color-white);
        background: var(--color-livique-anthrazit);
      }

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }

  .separator {
    width: 1px;
    height: 35px;
    background: var(--color-silver);
  }
}

.pagination-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100px;
  margin: 0 auto;
  font-family: var(--primary-font);

  select {
    display: block;
    width: auto;
    margin: 0 auto;
    border-radius: 3px;
    padding: 5px 10px;
    outline: none;
    cursor: pointer;
    border: 1px solid var(--color-silver);
    -webkit-appearance: none;
    padding-right: 25px;
    margin-right: 0;
    font-size: 14px;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position: 90% 50%;
    color: var(--color-nero);
  }
}
